export enum DeviceCommand {
    OPEN = 1,
    HARD_RESET = 79,
    SCANNER_RESET = 71,
    UUID_RESET = 70,
    DIAGNOSE = 80
}